import React from "react";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";

import styles from "./FavoriteButton.module.scss";
import { useFavoriteButton } from "./useFavoriteButton";

interface Props {
  itemId: number;
  isFavorite: boolean;
  onChange?: (itemId: number, isActive: boolean) => void;
  className?: string;
  size?: number;
}

export const FavoriteButton: React.FC<Props> = ({
  itemId,
  isFavorite,
  onChange,
  className,
  size = 20,
}) => {
  const { active, loading, isAuthorized, handleClick } = useFavoriteButton({
    itemId,
    isFavorite,
    onChange,
  });

  if (!isAuthorized) {
    return <span className={styles.Placeholder} aria-hidden="true" />;
  }

  return (
    <button
      type="button"
      className={`${styles.Button} ${active ? styles.Active : ""} ${
        className ?? ""
      }`}
      onClick={handleClick}
      disabled={loading}
      aria-label={active ? "Убрать из избранного" : "Добавить в избранное"}
    >
      {active ? <MdFavorite size={size} /> : <MdFavoriteBorder size={size} />}
    </button>
  );
};
